import type { CatalogEvent } from "@/features/catalog/mediators/catalogEvents";
import { createMediator, type Mediator } from "@/shared/lib/componentHierarchy";

type CatalogGridEvent = Extract<
  CatalogEvent,
  { type: "catalog/retry-requested" | "catalog/refresh-requested" }
>;

export function createCatalogGridMediator(
  runEffect: (event: CatalogGridEvent) => void,
): Mediator<Record<string, never>, CatalogGridEvent, CatalogGridEvent> {
  return createMediator(
    {},
    (state, event) => ({
      status: "handled",
      state,
      effects: [event],
    }),
    { runEffect },
  );
}
